import React from 'react';

import {
  AmericanExpress,
  DefaultCard,
  DinersClub,
  Discover,
  JCB,
  Mada,
  Maestro,
  Mastercard,
  UnionPay,
  Visa,
} from '../svgs';

export const getCardIcon = (cardType: string) => {
  switch (cardType) {
    case 'american_express':
      return <AmericanExpress />;
    case 'diners_club':
      return <DinersClub />;
    case 'discover':
      return <Discover />;
    case 'jcb':
      return <JCB />;
    case 'mada':
      return <Mada />;
    case 'maestro':
      return <Maestro />;
    case 'mastercard':
      return <Mastercard />;
    case 'union_pay':
      return <UnionPay />;
    case 'visa':
      return <Visa />;
    case 'unknown':
    default:
      return <DefaultCard />;
  }
};
